import { TextFieldProps } from "@mui/material";
import { FieldProps } from "formik";
import React from "react";
import FormikTextField from "./FormikTextField";

interface Props {
  rows?: number;
}

const FormikTextArea: React.FC<FieldProps & TextFieldProps & Props> = (
  props
) => {
  const { rows } = props;
  return <FormikTextField {...props} multiline rows={rows ?? 4} />;
};

export default FormikTextArea;
